// extracted by mini-css-extract-plugin
module.exports = {"section":"section__1t_ql","title":"title__2ep3l","section-body":"section-body__1wKf6"};